import DatePickerLocale from 'rmc-date-picker/lib/locale/sv_SE';
export default DatePickerLocale;
